export interface Skill {
  name: string;
  category: string;
  members: string[];
}

export interface SkillCategory {
  name: string;
  nameVi: string;
  skills: Skill[];
}

export const skillCategories: SkillCategory[] = [
  {
    name: 'Languages',
    nameVi: 'Ngon ngu lap trinh',
    skills: [
      { name: 'Node.js', category: 'languages', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'Go', category: 'languages', members: ['thanh-dm'] },
      { name: 'Python', category: 'languages', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'TypeScript', category: 'languages', members: ['thanh-dm', 'nghia-lv'] },
      { name: 'C#', category: 'languages', members: ['thanh-dm'] },
      { name: 'PHP', category: 'languages', members: ['phat-tvp'] },
      { name: 'Coldfusion', category: 'languages', members: ['nghia-lv'] },
      { name: 'HTML/CSS', category: 'languages', members: ['phat-tvp', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'JavaScript', category: 'languages', members: ['phat-tvp', 'nghia-lv', 'nguyen-lmt'] },
    ],
  },
  {
    name: 'Frameworks',
    nameVi: 'Framework',
    skills: [
      { name: 'NestJS', category: 'frameworks', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'Express', category: 'frameworks', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'HapiJS', category: 'frameworks', members: ['thanh-dm'] },
      { name: 'Django', category: 'frameworks', members: ['thanh-dm'] },
      { name: 'ASP.NET', category: 'frameworks', members: ['thanh-dm'] },
      { name: 'Astro', category: 'frameworks', members: ['thanh-dm'] },
      { name: 'Bootstrap', category: 'frameworks', members: ['phat-tvp'] },
      { name: 'React', category: 'frameworks', members: ['nghia-lv', 'nguyen-lmt'] },
      { name: 'jQuery', category: 'frameworks', members: ['phat-tvp'] },
      { name: 'TypeORM', category: 'frameworks', members: ['thanh-dm', 'nghia-lv'] },
      { name: 'Next.js', category: 'frameworks', members: ['nguyen-lmt'] },
      { name: 'Vue.js', category: 'frameworks', members: ['nguyen-lmt'] },
      { name: 'FastAPI', category: 'frameworks', members: ['nguyen-lmt'] },
      { name: 'Angular', category: 'frameworks', members: ['nguyen-lmt'] },
      { name: 'Tailwind CSS', category: 'frameworks', members: ['nguyen-lmt'] },
      { name: 'React Native', category: 'frameworks', members: ['nguyen-lmt'] },
    ],
  },
  {
    name: 'CMS/Builders',
    nameVi: 'CMS/Cong cu xay dung',
    skills: [
      { name: 'WordPress', category: 'cms', members: ['phat-tvp'] },
      { name: 'Duda', category: 'cms', members: ['phat-tvp'] },
      { name: 'Wix', category: 'cms', members: ['phat-tvp'] },
      { name: 'Squarespace', category: 'cms', members: ['phat-tvp'] },
      { name: 'GoHighLevel', category: 'cms', members: ['phat-tvp'] },
      { name: 'DIVI', category: 'cms', members: ['phat-tvp'] },
      { name: 'Flatsome', category: 'cms', members: ['phat-tvp'] },
    ],
  },
  {
    name: 'Cloud & DevOps',
    nameVi: 'Cloud & DevOps',
    skills: [
      { name: 'AWS', category: 'cloud', members: ['thanh-dm', 'nguyen-lmt'] },
      { name: 'Azure', category: 'cloud', members: ['thanh-dm'] },
      { name: 'Google Cloud', category: 'cloud', members: ['thanh-dm'] },
      { name: 'Docker', category: 'cloud', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'GitHub Actions', category: 'cloud', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'Serverless', category: 'cloud', members: ['thanh-dm'] },
      { name: 'GitHub Submodule', category: 'cloud', members: ['thanh-dm'] },
      { name: 'LocalStack', category: 'cloud', members: ['nguyen-lmt'] },
    ],
  },
  {
    name: 'Design Tools',
    nameVi: 'Cong cu thiet ke',
    skills: [
      { name: 'Figma', category: 'design', members: ['phat-tvp'] },
      { name: 'Adobe Photoshop', category: 'design', members: ['phat-tvp'] },
      { name: 'Adobe Illustrator', category: 'design', members: ['phat-tvp'] },
    ],
  },
  {
    name: 'Databases',
    nameVi: 'Co so du lieu',
    skills: [
      { name: 'PostgreSQL', category: 'databases', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'MongoDB', category: 'databases', members: ['thanh-dm', 'nghia-lv'] },
      { name: 'SQL Server', category: 'databases', members: ['thanh-dm', 'nghia-lv'] },
      { name: 'MySQL', category: 'databases', members: ['nguyen-lmt'] },
      { name: 'DynamoDB', category: 'databases', members: ['nguyen-lmt'] },
    ],
  },
  {
    name: 'Other',
    nameVi: 'Khac',
    skills: [
      { name: 'Code Review', category: 'other', members: ['thanh-dm', 'nguyen-lmt'] },
      { name: 'Clean Architecture', category: 'other', members: ['thanh-dm', 'nguyen-lmt'] },
      { name: 'Agile/Scrum', category: 'other', members: ['thanh-dm', 'nghia-lv', 'nguyen-lmt'] },
      { name: 'Stripe', category: 'other', members: ['thanh-dm'] },
      { name: 'Momo', category: 'other', members: ['thanh-dm'] },
      { name: 'SEO Optimization', category: 'other', members: ['phat-tvp'] },
      { name: 'Website Auditor', category: 'other', members: ['phat-tvp'] },
      { name: 'Responsive Design', category: 'other', members: ['phat-tvp'] },
      { name: 'UI/UX Design', category: 'other', members: ['phat-tvp'] },
      { name: 'Performance Optimization', category: 'other', members: ['phat-tvp'] },
      { name: 'TDD', category: 'other', members: ['nguyen-lmt'] },
      { name: 'REST API', category: 'other', members: ['nguyen-lmt'] },
      { name: 'Socket.IO', category: 'other', members: ['nguyen-lmt'] },
      { name: 'Redis', category: 'other', members: ['nguyen-lmt'] },
      { name: 'Google Maps API', category: 'other', members: ['nguyen-lmt'] },
    ],
  },
];
